import React, { useEffect, useContext, useState, useCallback, useRef } from "react";
import { useHistory,useParams } from "react-router-dom";

import axios from "axios";

import { BASE_URL } from "../../../../../BaseUrl";

//functions
import {
  getCookie,
  tableLoading,
  formatPrice,
  customStyle,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";
import { useCustomHooks } from "../../../../../functions/Hooks";
import { useOptimizedSelect } from "../../../../../hooks/useDebounceCustomer";

//3rd party packages
import { Helmet } from "react-helmet";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


//pages & includes
import AccountsSidebar from "../AccountsSidebar";

//context consumer
// import { SettingsContext } from "../../../../../contexts/Settings";
// import { UserContext } from "../../../../../contexts/User";
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { FinanceContext } from "../../../../../contexts/Finance";
import { ToastError, ToastSuccess } from "../../../../../functions/ToastShow";

const initialBankPaymentState = {
  doc_date: new Date(),
  transactionAccount: "",
  customerName: "",
  branch: "",
  remarks: "",
};

const initialRowState = (rowId) => ({
  id: rowId,
  account_name: "",
  cheque_date: new Date(),
  cheque_no: "",
  amount: "",
  tax_percent: 0,
  tax_amount: "",
  wht_percent: 0,
  wht_amount: "",
  net_amount: "",
  remarks: "",
});

const BankRecepitForm = () => {

  const { t } = useTranslation();
  const history = useHistory();
  const params=useParams();

  
  const { roundOffStock, qtyAmountPoints } = useCustomHooks();
  // const { getCustomer, customerForSearch } = useContext(UserContext);

  const { branchForSearch } = useContext(RestaurantContext);

    const {
      loading,
      setLoading,
      cao3Active,
      coa3ForSearch,
      dataPaginating,
    } = useContext(FinanceContext);

  const [newRow, setNewRow] = useState([]);
  let rowId=useRef(0);

  const [overflowStyle, setOverflowStyle] = useState(false);
  const [bankRecepit, setBankRecepit] = useState(initialBankPaymentState);
  const [totalRowAmount, setTotalRowAmount] = useState(0);
  const [totalRowWhtAmount, setTotalRowWhtAmount] = useState(0);
  const [totalRowTaxAmount, setTotalRowTaxAmount] = useState(0);
  const [totalRowNetAmount, setTotalRowNetAmount] = useState(0);
  const [bankAccounts, setBankAccounts] = useState(null);

  // Fetch Bank Transaction Accounts by Branch
  const getTransactionAccount = useCallback(async (branch_id) => {
    const url = `${BASE_URL}/settings/get-bank-account/${branch_id}`;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setBankAccounts(res.data);
      return res.data
    } catch (error) {
      if (error.response?.data?.status === 0) {
        ToastError({ title: t(error.response.data.message) });
      }
    } finally {
      setLoading(false);
    }
  }, [setLoading, t]);

  // Removed getCustomer() call on Mount

  //Fetech Edit Recipt
  useEffect(()=>{
    if(params.id && coa3ForSearch){
      getSpecificAccount()
    }
  },[coa3ForSearch])

  const getSpecificAccount = async () => {
    setLoading(true);
    const url =
      BASE_URL + "/settings/bank-receipt/" + parseInt(params.id);
    try {
      const res = await axios
        .get(url, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });
        if(res){
          const editAccount = res.data;
          if(editAccount && editAccount !== null && branchForSearch){
            let docDate=new Date(editAccount.document_date);
            let branch = branchForSearch.find((item)=>editAccount.branch_id == item.id);
            const bankAcc = await getTransactionAccount(branch.id);
            let transAcc=bankAcc?.find((item)=>editAccount.transaction_account_id == item.id)
            // let custAcc=customerForSearch?.find((item)=>editAccount.customer_id == item.id);
            setBankRecepit({
              ...bankRecepit,
              doc_no:editAccount.document_identity,
              doc_date:docDate,
              branch,
              remarks:editAccount.remarks,
              transactionAccount:transAcc,
              customerName:editAccount?.customer || ""
            })
           
            let rowArr=[]
            // let rowEditId=0
            if(editAccount.bankreceiptdetail && editAccount.bankreceiptdetail.length > 0){
                try {
                    editAccount.bankreceiptdetail.map((item)=>{
                        let acc_name= coa3ForSearch?.find((v,i)=>item.coa_id==v.id) 
                        rowArr.push({
                          id:rowId.current,
                          account_name:acc_name,
                          cheque_date: item.cheque_date ? new Date(item.cheque_date) : null,
                          cheque_no:item.cheque_no,
                          amount:roundOffStock(item.amount),
                          tax_percent:roundOffStock(item.other_tax_percent),
                          tax_amount:roundOffStock(item.other_tax_amount),
                          wht_percent:roundOffStock(item.wht_percent),
                          wht_amount:roundOffStock(item.wht_amount),
                          net_amount:roundOffStock(item.net_amount),
                          remarks:item.remarks
                        })
        
                        rowId.current += 1
                        // rowEditId++;
                      })
                } catch (error) {
                  console.log(error,"error");
                }

              setNewRow([...rowArr]);
            }
            setTotalRowAmount(roundOffStock(editAccount.total_amount));
            setTotalRowTaxAmount(roundOffStock(editAccount.total_other_tax_amount));
            setTotalRowWhtAmount(roundOffStock(editAccount.total_wht_amount));
            setTotalRowNetAmount(roundOffStock(editAccount.total_net_amount));
          }
        }
        setLoading(false);
    } catch (error) {
      console.log(error,"getSpecificAccount error");
      setLoading(false);
    }
  };

  // Save Account Handler
  const saveAccount = async (formData) => {

    setLoading(true);

    const endpoint = params.id ? `/settings/bank-receipt/${params.id}` : "/settings/bank-receipt";
    const url = BASE_URL + endpoint;
    const method = params.id ? "put" : "post";

    try {
      const res = await axios[method](
        url,
        formData,
        { headers: { Authorization: `Bearer ${getCookie()}` } },
      );
      setLoading(false);
      if (res.data) {
        const msg= params.id ? t("Bank receipt has been updated") : t("Bank receipt has been added");
        ToastSuccess({ title: msg, autoClose: 10000 });
        history.push("/dashboard/account/transaction/bank-receipt");
      }
    } catch {
      setLoading(false);
      ToastError({ title: t("Please try again later"), autoClose: 10000 });
    }
  };


  // Calculate net/tax/wht for a row
  const accCalculation = useCallback((row, field, index) => {
    // Modifies row array mutably, then sets state immutably
    let calcRow = [...row];
    let cur = calcRow[index];
    if (field === "amount") {
      cur.tax_amount = isNaN(cur.amount * cur.tax_percent / 100)
        ? 0
        : roundOffStock(cur.amount * cur.tax_percent / 100);
      cur.wht_amount = isNaN(cur.amount * cur.wht_percent / 100)
        ? 0
        : roundOffStock(cur.amount * cur.wht_percent / 100);
    } else if (field === "tax_percent") {
      cur.tax_amount = isNaN(cur.amount * cur.tax_percent / 100)
        ? 0
        : roundOffStock(cur.amount * cur.tax_percent / 100);
    } else if (field === "wht_percent") {
      cur.wht_amount = isNaN(cur.amount * cur.wht_percent / 100)
        ? 0
        : roundOffStock(cur.amount * cur.wht_percent / 100);
    }
    cur.net_amount = roundOffStock(
      (parseFloat(cur.amount) || 0) -
        (parseFloat(cur.tax_amount) || 0) -
        (parseFloat(cur.wht_amount) || 0)
    );
    setNewRow(calcRow);
    calcTotals(calcRow);
    // eslint-disable-next-line
  }, [roundOffStock]);

  // Calculate Totals
  const calcTotals = useCallback((rows) => {
    const total = (k) => rows.reduce((acc, v) => {
      const val = parseFloat(v[k]);
      return acc + (isNaN(val) ? 0 : val);
    }, 0);
    setTotalRowAmount(roundOffStock(total("amount")));
    setTotalRowTaxAmount(roundOffStock(total("tax_amount")));
    setTotalRowWhtAmount(roundOffStock(total("wht_amount")));
    setTotalRowNetAmount(roundOffStock(total("net_amount")));
  }, [roundOffStock]);

  // Form Handlers
  const handleSubmit = (e) => {

    e.preventDefault();

    if (!bankRecepit.transactionAccount) {
      return ToastError({ title: t("Please select transaction account"), autoClose: 10000 });
    }

    if (!bankRecepit.branch) {
      return ToastError({ title: t("Please select branch"), autoClose: 10000 });
    }

    if (!newRow.length) {
      return ToastError({ title: t("Please add accounts"), autoClose: 10000 });
    }

    const noFilledRows = newRow.filter((v) => !v.account_name);

    if (noFilledRows.length > 0) {
      return ToastError({ title: t("Please select account name"), autoClose: 10000 });
    }

    const rowObjects = newRow.map((v) => ({
      coa_id: v.account_name.id,
      cheque_date: v.cheque_date
        ? `${v.cheque_date.getFullYear()}-${parseInt(v.cheque_date.getMonth() + 1)}-${v.cheque_date.getDate()}`
        : "",
      cheque_no: v.cheque_no,
      amount: v.amount,
      other_tax_percent: isNaN(v.tax_percent) ? 0 : parseFloat(v.tax_percent),
      other_tax_amount: parseFloat(v.tax_amount),
      wht_percent: isNaN(v.wht_percent) ? 0 : parseFloat(v.wht_percent),
      wht_amount: parseFloat(v.wht_amount),
      net_amount: parseFloat(v.net_amount),
      remarks: v.remarks,
    }));

    let docDate = `${bankRecepit.doc_date.getFullYear()}-${parseInt(bankRecepit.doc_date.getMonth()) + 1}-${bankRecepit.doc_date.getDate()}`;
    let saveObj = {
      document_date: docDate,
      transaction_account_id: bankRecepit.transactionAccount.id,
      customer_id: bankRecepit.customerName ? bankRecepit.customerName.id : "",
      branch_id: bankRecepit.branch?.id,
      remarks: bankRecepit.remarks,
      rows: rowObjects,
      total_amount: totalRowAmount,
      total_wht_amount: totalRowWhtAmount,
      total_other_tax_amount: totalRowTaxAmount,
      total_net_amount: totalRowNetAmount,
    };

    saveAccount(saveObj);

  };

  // Input/Event Handlers
  const handleDocDate = (date) =>
    setBankRecepit((prev) => ({ ...prev, doc_date: date }));

  const handleTransactionAcc = (acc) =>
    setBankRecepit((prev) => ({ ...prev, transactionAccount: acc }));

  const handleBranch = (branch) => {
    if (branch?.id !== bankRecepit.branch?.id) {
      setBankRecepit((prev) => ({
        ...prev,
        branch,
        transactionAccount: "",
      }));
      getTransactionAccount(branch.id);
    }
  };

  const handleSetCustomer = (customer) =>
    setBankRecepit((prev) => ({ ...prev, customerName: customer }));

  const handleRemarks = (remarks) =>
    setBankRecepit((prev) => ({ ...prev, remarks }));

  // Row Handlers
  const addNewRow = () => {
    let row_Id = rowId.current;
    setNewRow((prev) => [...prev, initialRowState(row_Id)]);
    rowId.current += 1;
  };

  const delRow = (id) => {
    const filtered = newRow.filter((item) => id !== item.id);
    setNewRow(filtered);
    calcTotals(filtered);
  };

  const handleAccountName = (index, acc) => {
    let updatedRows = [...newRow];
    updatedRows[index].account_name = acc;
    setNewRow(updatedRows);
    setOverflowStyle(false);
  };

  const handleChequeDate = (index, date) => {
    let updatedRows = [...newRow];
    updatedRows[index].cheque_date = date;
    setNewRow(updatedRows);
  };

  const handleChequeNo = (index, e) => {
    let updatedRows = [...newRow];
    updatedRows[index].cheque_no = e.target.value;
    setNewRow(updatedRows);
  };

  const handleAmt = (index, e) => {
    let updatedRows = [...newRow];
    updatedRows[index].amount = Number(e.target.value);
    setNewRow(updatedRows);
    accCalculation(updatedRows, "amount", index);
  };

  const handleTaxPercent = (index, e) => {
    let updatedRows = [...newRow];
    updatedRows[index].tax_percent = parseFloat(e.target.value);
    setNewRow(updatedRows);
    accCalculation(updatedRows, "tax_percent", index);
  };

  const handleWhtPercent = (index, e) => {
    let updatedRows = [...newRow];
    updatedRows[index].wht_percent = parseFloat(e.target.value);
    setNewRow(updatedRows);
    accCalculation(updatedRows, "wht_percent", index);
  };

  const handleRowRemarks = (index, e) => {
    let updatedRows = [...newRow];
    updatedRows[index].remarks = e.target.value;
    setNewRow(updatedRows);
  };

  const {
    inputValue: customerInput,
    onInputChange: onCustomerInputChange,
    options: customerOptions,
    isLoading: isCustomerLoading
  } = useOptimizedSelect("/settings/get-all-customer", {
    selectedOption: bankRecepit.customerName
  });

  // Render
    return (
        <>
            <Helmet>
                <title>{t(params.id ? "Edit Bank Recepit" : "Add Bank Recepit")}</title>
            </Helmet>
            <main id="main" data-simplebar>
                <div className="container-fluid">
                    <div className="row t-mt-10 gx-2">
                        {/* Sidebar */}
                        <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
                            <AccountsSidebar />
                        </div>
                        {/* Rightbar */}
                        <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
                            <div className="t-bg-white">
                                <div className="fk-scroll--pos-menu table-bottom-info-hide" data-simplebar>
                                    <div className="t-pl-15 t-pr-15">
                                        <div className={`${dataPaginating && "loading"}`}></div>
                                        {loading ? (
                                            tableLoading()
                                        ) : (
                                            <div key="smtp-form">
                                                <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                                                    <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                                                        <ul className="t-list fk-breadcrumb">
                                                            <li className="fk-breadcrumb__list">
                                                                <span className="t-link fk-breadcrumb__link text-capitalize">
                                                                    {t(params.id ? "Edit Bank Recepit" : "Add Bank Recepit")}
                                                                </span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-md-6 col-lg-7"></div>
                                                </div>
                                                {/* Form */}
                                                <form
                                                    className="row card p-2 mx-3 mb-5 table-text"
                                                    onSubmit={handleSubmit}
                                                    autoComplete="off"
                                                >
                                                    <div className="col-12">
                                                        {/* Form Fields */}
                                                        <div className="row">
                                                            <div className="form-group col-4 mt-2">
                                                                <div className="mb-2">
                                                                    <label htmlFor="invoice" className="control-label">
                                                                        {t("Document #")}
                                                                    </label>
                                                                </div>
                                                                <div className="mb-2">
                                                                    <input
                                                                        disabled
                                                                        type="text"
                                                                        className="form-control table-text"
                                                                        id="invoice"
                                                                        name="invoice"
                                                                        placeholder="Auto No"
                                                                        value={bankRecepit.doc_no||"Auto No"}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="form-group col-4 text-right mt-2">
                                                                <div className="mb-2 text-left">
                                                                    <label htmlFor="purchaseDate" className="control-label">
                                                                        {t("Document Date")}
                                                                        <span className="text-danger">*</span>
                                                                    </label>
                                                                </div>
                                                                <div className="mb-2">
                                                                    <DatePicker
                                                                        selected={bankRecepit.doc_date}
                                                                        onChange={handleDocDate}
                                                                        peekNextMonth
                                                                        showMonthDropdown
                                                                        showYearDropdown
                                                                        dropdownMode="select"
                                                                        className="form-control table-text"
                                                                        placeholderText={t("Document date")}
                                                                        shouldCloseOnSelect={false}
                                                                        required
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="form-group mt-2 col-4">
                                                                <div className="mb-2 text-left">
                                                                    <label htmlFor="branch" className="control-label">
                                                                        {t("Branch")}
                                                                        <span className="text-danger">*</span>
                                                                    </label>
                                                                </div>
                                                                <Select
                                                                    options={branchForSearch || []}
                                                                    components={makeAnimated()}
                                                                    getOptionLabel={option => option.name}
                                                                    getOptionValue={option => option.id}
                                                                    value={bankRecepit.branch || ""}
                                                                    classNamePrefix="select table-text"
                                                                    onChange={handleBranch}
                                                                    placeholder={t("Please select branch") + ".."}
                                                                    styles={customStyle}
                                                                    required
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="form-group mt-2 col-4">
                                                                <div className="mb-2 text-left">
                                                                    <label htmlFor="transaction" className="control-label">
                                                                        {t("Transaction Account")}
                                                                        <span className="text-danger">*</span>
                                                                    </label>
                                                                </div>
                                                                <Select
                                                                    options={bankAccounts || []}
                                                                    components={makeAnimated()}
                                                                    getOptionLabel={option => option.level3_name}
                                                                    getOptionValue={option => option.id}
                                                                    value={bankRecepit.transactionAccount || ""}
                                                                    classNamePrefix="select table-text"
                                                                    onChange={handleTransactionAcc}
                                                                    placeholder={t("Please select an account") + ".."}
                                                                    styles={customStyle}
                                                                    required
                                                                />
                                                            </div>
                                                            <div className="form-group mt-2 col-4">
                                                                <div className="mb-2">
                                                                    <label htmlFor="item" className="control-label">
                                                                        {t("Customer")}
                                                                    </label>
                                                                </div>
                                                                <Select
                                                                    options={customerOptions}
                                                                    isLoading={isCustomerLoading}
                                                                    inputValue={customerInput}
                                                                    onInputChange={onCustomerInputChange}
                                                                    filterOption={null}
                                                                    backspaceRemovesValue={false}
                                                                    getOptionLabel={option => option.name_phone || option.name}
                                                                    getOptionValue={option => option.id}
                                                                    value={bankRecepit?.customerName}
                                                                    classNamePrefix="select table-text"
                                                                    onChange={handleSetCustomer}
                                                                    isClearable
                                                                    placeholder={t("Please select a customer") + ".."}
                                                                    styles={customStyle}
                                                                />
                                                            </div>
                                                            <div className="form-group mt-2 col-4">
                                                                <div className="mb-2">
                                                                    <label htmlFor="description" className="control-label">
                                                                        {t("Remarks")}
                                                                    </label>
                                                                </div>
                                                                <div className="mb-2">
                                                                    <input
                                                                        type="text"
                                                                        className="form-control table-text"
                                                                        id="description"
                                                                        name="description"
                                                                        onChange={(e) => handleRemarks(e.target.value)}
                                                                        value={bankRecepit.remarks}
                                                                        placeholder="Short description"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>


                                                        {/* Table */}
                                                        <div
                                                            className={`table-responsive pt-3 mt-2 pr-1 ${overflowStyle ? "add-bank-table" : "overflow-visible"}`}
                                                            style={{ maxHeight: "23rem", overflow: "auto" }}
                                                        >
                                                            <table className="table table-bordered-sm table-hover">
                                                                <thead className="align-middle">
                                                                    <tr>
                                                                        {newRow.length === 0 ? (
                                                                            <th className="table-text text-capitalize align-middle text-center border-1 border">
                                                                                <span className="t-mr-10" onClick={addNewRow}>
                                                                                    <i className="fa fa-plus-circle cursor-pointer btn-add-icon" style={{ fontSize: "22px" }} aria-hidden="true"></i>
                                                                                </span>
                                                                            </th>
                                                                        ) : (
                                                                            <th style={{ borderBottomColor: "lightgray" }}></th>
                                                                        )}
                                                                        {[
                                                                            "Account name",
                                                                            "Cheque Date",
                                                                            "Cheque No",
                                                                            "Amount",
                                                                            "Tax Percent",
                                                                            "Tax amount",
                                                                            "WHT Percent",
                                                                            "WHT Amount",
                                                                            "Net Amount",
                                                                            "Remarks",
                                                                        ].map((label, idx) => (
                                                                            <th
                                                                                key={label}
                                                                                scope="col"
                                                                                className="table-text text-capitalize align-middle text-center border-1 border"
                                                                                style={["Account name"].includes(label) ? { minWidth: "120px" } : undefined}
                                                                            >
                                                                                <span style={{ fontWeight: 500 }}>{t(label)}</span>
                                                                            </th>
                                                                        ))}
                                                                        {newRow.length > 0 && <th style={{ borderBottomColor: "lightgray", minWidth: "60px" }}></th>}
                                                                    </tr>
                                                                </thead>
                                                                <tbody className="align-middle">
                                                                    {newRow.length > 0
                                                                        ? newRow.map((v, i) => (
                                                                            <tr className="align-middle" key={v.id}>
                                                                                <td className="table-text text-capitalize align-middle text-center table-firstChild" style={{ minWidth: "60px" }}>
                                                                                    {i === newRow.length - 1 && (
                                                                                        <span className="t-mr-10" onClick={addNewRow}>
                                                                                            <i className="fa fa-plus-circle btn-add-icon" style={{ fontSize: "22px" }} aria-hidden="true"></i>
                                                                                        </span>
                                                                                    )}
                                                                                    &nbsp;
                                                                                    <i className="fa fa-minus-circle cursor-pointer text-danger" style={{ fontSize: "22px" }} onClick={() => delRow(v.id)}></i>
                                                                                </td>
                                                                                <td className="table-text text-capitalize align-middle" style={{ minWidth: "250px" }}>
                                                                                    <Select
                                                                                        menuPlacement={newRow.length > 3 && i > 2 ? "top" : "bottom"}
                                                                                        options={cao3Active || []}
                                                                                        components={makeAnimated()}
                                                                                        getOptionLabel={(option) => option.level3_name}
                                                                                        getOptionValue={(option) => option.id}
                                                                                        value={v.account_name || ""}
                                                                                        onChange={(e) => handleAccountName(i, e)}
                                                                                        maxMenuHeight="12.8rem"
                                                                                        placeholder={t("Account Name")}
                                                                                        isMenuOpen={true}
                                                                                        styles={customStyle}
                                                                                        className="bank-table-input"
                                                                                        required
                                                                                        onFocus={() => {
                                                                                            if (newRow.length > 0 && newRow.length < 5) setOverflowStyle(true);
                                                                                        }}
                                                                                        onBlur={() => setOverflowStyle(false)}
                                                                                        onMenuOpen={() => {
                                                                                            if (newRow.length > 0 && newRow.length < 5) setOverflowStyle(true);
                                                                                        }}
                                                                                        onMenuClose={() => setOverflowStyle(false)}
                                                                                    />
                                                                                </td>
                                                                                <td className="table-text text-capitalize align-middle text-center" style={{ minWidth: "120px" }}>
                                                                                    <DatePicker
                                                                                        selected={v.cheque_date}
                                                                                        onChange={(date) => handleChequeDate(i, date)}
                                                                                        peekNextMonth
                                                                                        showMonthDropdown
                                                                                        showYearDropdown
                                                                                        dropdownMode="select"
                                                                                        className="form-control table-text"
                                                                                        placeholderText={t("Cheque date")}
                                                                                        shouldCloseOnSelect={false}
                                                                                    />
                                                                                </td>
                                                                                <td className="table-text text-capitalize align-middle text-center" style={{ minWidth: "130px" }}>
                                                                                    <input
                                                                                        type="number"
                                                                                        min="0"
                                                                                        onKeyDown={(evt) =>
                                                                                            ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(evt.key) && evt.preventDefault()
                                                                                        }
                                                                                        onWheel={(e) => e.target.blur()}
                                                                                        className="form-control text-center table-Input table-text"
                                                                                        onChange={(e) => handleChequeNo(i, e)}
                                                                                        value={v.cheque_no}
                                                                                        placeholder="cheque no"
                                                                                    />
                                                                                </td>
                                                                                <td className="table-text text-capitalize align-middle text-center" style={{ minWidth: "140px" }}>
                                                                                    <input
                                                                                        type="number"
                                                                                        step={qtyAmountPoints()}
                                                                                        min="0"
                                                                                        onKeyDown={(evt) =>
                                                                                            ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(evt.key) && evt.preventDefault()
                                                                                        }
                                                                                        onWheel={(e) => e.target.blur()}
                                                                                        className="form-control text-center table-Input table-text"
                                                                                        onChange={(e) => handleAmt(i, e)}
                                                                                        placeholder="0"
                                                                                        required
                                                                                        value={v.amount}
                                                                                    />
                                                                                </td>
                                                                                <td className="table-text text-capitalize align-middle text-center">
                                                                                    <input
                                                                                        type="number"
                                                                                        step={qtyAmountPoints()}
                                                                                        min="0"
                                                                                        onKeyDown={(evt) =>
                                                                                            ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(evt.key) && evt.preventDefault()
                                                                                        }
                                                                                        onWheel={(e) => e.target.blur()}
                                                                                        className="form-control text-center table-Input table-text"
                                                                                        onChange={(e) => handleTaxPercent(i, e)}
                                                                                        placeholder="0"
                                                                                        value={v.tax_percent || ""}
                                                                                    />
                                                                                </td>
                                                                                <td className="table-text text-capitalize align-middle text-center" style={{ minWidth: "140px" }}>
                                                                                    <input
                                                                                        readOnly
                                                                                        type="number"
                                                                                        step={qtyAmountPoints()}
                                                                                        min="0"
                                                                                        onKeyDown={(evt) =>
                                                                                            ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(evt.key) && evt.preventDefault()
                                                                                        }
                                                                                        onWheel={(e) => e.target.blur()}
                                                                                        className="form-control text-center table-Input table-text"
                                                                                        placeholder="0"
                                                                                        value={v.tax_amount}
                                                                                    />
                                                                                </td>
                                                                                <td className="table-text text-capitalize align-middle text-center">
                                                                                    <input
                                                                                        type="number"
                                                                                        step={qtyAmountPoints()}
                                                                                        min="0"
                                                                                        onKeyDown={(evt) =>
                                                                                            ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(evt.key) && evt.preventDefault()
                                                                                        }
                                                                                        onWheel={(e) => e.target.blur()}
                                                                                        className="form-control text-center table-Input table-text"
                                                                                        onChange={(e) => handleWhtPercent(i, e)}
                                                                                        placeholder="0"
                                                                                        value={v.wht_percent || ""}
                                                                                    />
                                                                                </td>
                                                                                <td className="table-text text-capitalize align-middle text-center" style={{ minWidth: "140px" }}>
                                                                                    <input
                                                                                        type="number"
                                                                                        readOnly
                                                                                        step={qtyAmountPoints()}
                                                                                        min="0"
                                                                                        onKeyDown={(evt) =>
                                                                                            ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(evt.key) && evt.preventDefault()
                                                                                        }
                                                                                        onWheel={(e) => e.target.blur()}
                                                                                        className="form-control text-center table-Input table-text"
                                                                                        placeholder="0"
                                                                                        value={v.wht_amount}
                                                                                        required
                                                                                    />
                                                                                </td>
                                                                                <td className="table-text text-capitalize align-middle text-center" style={{ minWidth: "140px" }}>
                                                                                    <input
                                                                                        type="number"
                                                                                        readOnly
                                                                                        step={qtyAmountPoints()}
                                                                                        min="0"
                                                                                        onKeyDown={(evt) =>
                                                                                            ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(evt.key) && evt.preventDefault()
                                                                                        }
                                                                                        onWheel={(e) => e.target.blur()}
                                                                                        className="form-control text-center table-Input table-text"
                                                                                        placeholder="0"
                                                                                        value={v.net_amount}
                                                                                    />
                                                                                </td>
                                                                                <td className="table-text text-capitalize align-middle text-center" style={{ minWidth: "140px" }}>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control text-center table-Input table-text"
                                                                                        onChange={(e) => handleRowRemarks(i, e)}
                                                                                        placeholder="remarks"
                                                                                        value={v.remarks}
                                                                                    />
                                                                                </td>
                                                                                <td className="table-text text-capitalize align-middle text-center" style={{ minWidth: "60px" }}>
                                                                                    <i className="fa fa-minus-circle cursor-pointer text-danger" style={{ fontSize: "22px" }} onClick={() => delRow(v.id)}></i>
                                                                                    &nbsp;
                                                                                    {i === newRow.length - 1 && (
                                                                                        <span className="t-mr-10" onClick={addNewRow}>
                                                                                            <i className="fa fa-plus-circle cursor-pointer btn-add-icon" style={{ fontSize: "22px" }} aria-hidden="true"></i>
                                                                                        </span>
                                                                                    )}
                                                                                </td>
                                                                            </tr>
                                                                        ))
                                                                        : null}
                                                                </tbody>
                                                                {newRow.length > 0 && (
                                                                    <tfoot className="align-middle">
                                                                        <tr>
                                                                            <th colSpan="3" className="table-text text-capitalize align-middle text-center border-1 border"></th>
                                                                            <th colSpan="1" className="table-text text-capitalize align-middle text-center border-1 border">
                                                                                <span style={{ fontWeight: "bold" }}>{t("Total Amount")}</span>
                                                                            </th>
                                                                            <th style={{ minWidth: "100px" }} className="table-text text-capitalize align-middle text-center border-1 border font-weight-bold">
                                                                                <span style={{ fontWeight: "bold" }}>{formatPrice(totalRowAmount)}</span>
                                                                            </th>
                                                                            <th style={{ minWidth: "100px" }} className="table-text text-capitalize align-middle text-center border-1 border"></th>
                                                                            <th style={{ minWidth: "100px" }} className="table-text text-capitalize align-middle text-center border-1 border">
                                                                                <span style={{ fontWeight: "bold" }}>{formatPrice(totalRowTaxAmount)}</span>
                                                                            </th>
                                                                            <th style={{ minWidth: "100px" }} className="table-text text-capitalize align-middle text-center border-1 border"></th>
                                                                            <th style={{ minWidth: "100px" }} className="table-text text-capitalize align-middle text-center border-1 border">
                                                                                <span style={{ fontWeight: "bold" }}>{formatPrice(totalRowWhtAmount)}</span>
                                                                            </th>
                                                                            <th style={{ minWidth: "100px" }} className="table-text text-capitalize align-middle text-center border-1 border">
                                                                                <span style={{ fontWeight: "bold" }}>{formatPrice(totalRowNetAmount)}</span>
                                                                            </th>
                                                                            <th className="table-text text-capitalize align-middle text-center border-1 border"></th>
                                                                            <th className="table-text text-capitalize align-middle text-center border-1 border"></th>
                                                                        </tr>
                                                                    </tfoot>
                                                                )}
                                                            </table>
                                                        </div>
                                                        {/* Form Buttons */}
                                                        <div className="form-group mt-4 pb-2">
                                                            <div className="col-12 text-right">
                                                                <button
                                                                    className="btn hov-btn px-4 mr-3 rounded"
                                                                    type="button"
                                                                    onClick={() => history.push("/dashboard/account/transaction/bank-receipt")}
                                                                >
                                                                    <i className="fa fa-arrow-left" aria-hidden="true"></i> {t("Back")}
                                                                </button>
                                                                <button className="btn btn-primary px-4 rounded" type="submit">
                                                                    <i className="fa fa-floppy-o" aria-hidden="true"></i> {t(params.id ? "Update" : "Save")}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Rightbar contents end*/}
                    </div>
                </div>
            </main>
        </>
    );
};

export default BankRecepitForm;